export default {
  namespaced: true,
  state: {
    showDialog: false,
    error: [],
  },
  actions: {
    show({ commit }, error) {
      commit('show', error)
    },
    hide({ commit }) {
      commit('hide')
    },
  },
  mutations: {
    show(state, error) {
      state.showDialog = true
      state.error.push(error)
    },
    hide(state) {
      state.showDialog = false
      state.error = []
    },
  },
}
